<div [matTooltip]="value">
{{ value | stringDate }}
</div>
